// DATI DEL SITO RED STONE - modifica qui i contenuti, poi esegui: yarn build
// Ogni voce: category, name, description, price, allergens (separati da virgola), image, available (false = nascosto)
export const menuItems = [
  {
    "id": "0552c593-73d1-44a5-9566-df1f03557958",
    "category": "taglieri",
    "name": "Red Stone",
    "description": "Tagliere per una persona con selezione di salumi, formaggi e verdure grigliate - con focaccia calda",
    "price": "€9,00",
    "format": "",
    "allergens": "Latte, Glutine",
    "image": "",
    "available": true,
    "order": 0
  },
  {
    "id": "e2e6c8f0-df13-4f2b-b207-526d499e537e",
    "category": "taglieri",
    "name": "Red Stone XL",
    "description": "Tagliere con vasta selezione di salumi, formaggi, verdure grigliate e sfizi dello chef - con focaccia calda",
    "price": "€14,00",
    "format": "",
    "allergens": "Latte, Glutine",
    "image": "",
    "available": true,
    "order": 1
  },
  {
    "id": "54d18e4d-8975-4b41-bbf7-00611220a30d",
    "category": "taglieri",
    "name": "Ortolano",
    "description": "Tagliere con mozzarelline, pomodori secchi, frittelle alle zucchine, bruschetta al pomodoro, verdure grigliate e olive - con focaccia calda",
    "price": "€10,00",
    "format": "",
    "allergens": "Latte, Glutine",
    "image": "",
    "available": true,
    "order": 2
  },
  {
    "id": "1f4d1c51-449e-4b2c-b1b3-be92c26db1ce",
    "category": "fritti",
    "name": "Supplì di Antonietta",
    "description": "Pomodoro e mozzarella",
    "price": "€2,00",
    "format": "",
    "allergens": "Latte, Glutine, Uova",
    "image": "",
    "available": true,
    "order": 3
  },
  {
    "id": "2cbdd145-c632-4ada-bc9c-330e73b3513b",
    "category": "fritti",
    "name": "Crocchettona di Patate",
    "description": "Patate e mozzarella",
    "price": "€2,00",
    "format": "",
    "allergens": "Latte, Glutine, Uova",
    "image": "",
    "available": true,
    "order": 4
  },
  {
    "id": "e5234950-e49d-43b0-a710-a071c739ac5f",
    "category": "fritti",
    "name": "Alette di Pollo (4-5pz)",
    "description": "",
    "price": "€6,00",
    "format": "",
    "allergens": "Glutine, Uova",
    "image": "",
    "available": true,
    "order": 5
  },
  {
    "id": "6e7c7559-162a-4017-b520-7433f4df16e3",
    "category": "fritti",
    "name": "Olive Ascolane (6pz)",
    "description": "",
    "price": "€5,00",
    "format": "",
    "allergens": "Glutine",
    "image": "",
    "available": true,
    "order": 6
  },
  {
    "id": "85a2c8f5-590a-469e-b5b3-10aede779eaa",
    "category": "fritti",
    "name": "Frittelle Miste (8pz)",
    "description": "Mix di frittelline di pasta di pane alle zucchine, allo speck, ai peperoni, alle olive e ai capperi",
    "price": "€5,00",
    "format": "",
    "allergens": "Glutine",
    "image": "",
    "available": true,
    "order": 7
  },
  {
    "id": "49ca5495-ceed-4231-bd54-c1b3a3a5011a",
    "category": "fritti",
    "name": "Patatine Fritte",
    "description": "",
    "price": "€4,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 8
  },
  {
    "id": "d4b4b67b-6ddf-43b3-88bb-3e3a1442f49e",
    "category": "fritti",
    "name": "Jalapenos (3pz)",
    "description": "Ripieni di formaggio",
    "price": "€4,00",
    "format": "",
    "allergens": "Latte, Glutine",
    "image": "",
    "available": true,
    "order": 9
  },
  {
    "id": "672f4c13-f829-45c4-82a7-d46b51afc9e4",
    "category": "fritti",
    "name": "Nuggets (10pz)",
    "description": "Bocconcini di pollo",
    "price": "€5,00",
    "format": "",
    "allergens": "Glutine",
    "image": "",
    "available": true,
    "order": 10
  },
  {
    "id": "459beefb-80a0-4070-80dd-c7ccf6e6827c",
    "category": "pizze_speciali",
    "name": "La Scrocco",
    "description": "Mozzarella, guanciale e datterino giallo",
    "price": "€9,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 11
  },
  {
    "id": "57f1e48c-14f4-4941-8dd8-e859c572a697",
    "category": "pizze_speciali",
    "name": "La Quiz",
    "description": "Mozzarella, pomodori secchi sott'olio, salame piccante e stracciata di bufala",
    "price": "€10,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 12
  },
  {
    "id": "a8642770-e92c-4d84-a55d-8a31f339eeac",
    "category": "pizze_speciali",
    "name": "Calabria",
    "description": "Mozzarella di bufala, datterino giallo e nduja",
    "price": "€9,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 13
  },
  {
    "id": "4b18ee8b-100b-4fad-9789-2813b8f6af66",
    "category": "pizze_speciali",
    "name": "Ciociara",
    "description": "Focaccia con rucola, prosciutto crudo, pachino e stracciata di bufala",
    "price": "€9,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 14
  },
  {
    "id": "fd959af7-3665-4053-bafd-bbf550085179",
    "category": "pizze_speciali",
    "name": "Genovese",
    "description": "Focaccia, mortadella, stracciata di bufala e granella di pistacchio",
    "price": "€9,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 15
  },
  {
    "id": "d1e0e695-41a9-4899-9756-98d3cd07f0dc",
    "category": "pizze_speciali",
    "name": "Carbonara",
    "description": "Mozzarella, carbocrema, guanciale e pepe nero",
    "price": "€9,00",
    "format": "",
    "allergens": "Uova",
    "image": "",
    "available": true,
    "order": 16
  },
  {
    "id": "b6e7f91d-4e31-47cb-8724-7e8d15f51fa6",
    "category": "pizze_speciali",
    "name": "L'Imperiale",
    "description": "Mozzarella, pachino, scamorza, scaglie di parmigiano, crudo infornato",
    "price": "€10,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 17
  },
  {
    "id": "9cc85d7a-2c13-47b2-a2cb-6789dc764d3b",
    "category": "pizze_rosse",
    "name": "Margherita",
    "description": "Mozzarella, pomodoro e basilico fresco",
    "price": "€7,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 18
  },
  {
    "id": "9963258a-4712-41e2-bfb4-754d1432225d",
    "category": "pizze_rosse",
    "name": "Diavola",
    "description": "Mozzarella, pomodoro e salame piccante",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 19
  },
  {
    "id": "3e9c0417-6a7b-4019-a959-63b5e538d993",
    "category": "pizze_rosse",
    "name": "Bufalina",
    "description": "Mozzarella di bufala, pomodoro e basilico fresco",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 20
  },
  {
    "id": "129239cf-fc4b-40f0-8562-66d06da3c75b",
    "category": "pizze_rosse",
    "name": "Capricciosa",
    "description": "Mozzarella, pomodoro, olive nere, funghi, carciofini, prosciutto crudo e uova",
    "price": "€9,00",
    "format": "",
    "allergens": "Uova",
    "image": "",
    "available": true,
    "order": 21
  },
  {
    "id": "92919ed8-f236-4429-85f5-54d30f6862b9",
    "category": "pizze_rosse",
    "name": "Napoli",
    "description": "Mozzarella, pomodoro, alici",
    "price": "€7,00",
    "format": "",
    "allergens": "Pesce",
    "image": "",
    "available": true,
    "order": 22
  },
  {
    "id": "cf478587-b4c4-49e6-b0f3-05059dd8bda2",
    "category": "pizze_rosse",
    "name": "Parmigiana",
    "description": "Mozzarella, pomodoro, melanzane, parmigiano",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 23
  },
  {
    "id": "25a3b330-96bb-4e0b-9007-2363b4d17c9c",
    "category": "pizze_rosse",
    "name": "Tonno & Cipolla",
    "description": "Mozzarella, pomodoro, tonno e cipolla",
    "price": "€8,00",
    "format": "",
    "allergens": "Pesce",
    "image": "",
    "available": true,
    "order": 24
  },
  {
    "id": "178ee500-4475-4ace-bc35-fef0e8e89a63",
    "category": "pizze_rosse",
    "name": "Quattro Stagioni",
    "description": "Mozzarella, pomodoro, olive nere, funghi, carciofini e alici",
    "price": "€9,00",
    "format": "",
    "allergens": "Pesce",
    "image": "",
    "available": true,
    "order": 25
  },
  {
    "id": "b97bb79b-adf3-4503-9c24-cdd5f6def324",
    "category": "pizze_bianche",
    "name": "Broccoletti & Salsiccia",
    "description": "Mozzarella, broccoletti e salsiccia",
    "price": "€8,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 26
  },
  {
    "id": "2fea3045-39de-4fe2-8011-cc6d2fe19595",
    "category": "pizze_bianche",
    "name": "Caprese",
    "description": "Focaccia con mozzarella di bufala, pomodoro, basilico fresco e origano",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 27
  },
  {
    "id": "737bd4ff-87d1-4598-9573-882998dfeb07",
    "category": "pizze_bianche",
    "name": "Peperoni & Salsiccia",
    "description": "Mozzarella, peperoni e salsiccia",
    "price": "€8,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 28
  },
  {
    "id": "814aa995-0a41-45cb-9af6-f367c231ad0d",
    "category": "pizze_bianche",
    "name": "Patate & Cotto",
    "description": "Mozzarella, patate e prosciutto cotto",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 29
  },
  {
    "id": "d151ad1e-d000-4720-81c3-965c14880e98",
    "category": "pizze_bianche",
    "name": "Salmonata",
    "description": "Mozzarella, zucchine, pachino, salmone affumicato",
    "price": "€9,00",
    "format": "",
    "allergens": "Pesce",
    "image": "",
    "available": true,
    "order": 30
  },
  {
    "id": "2e84cf9e-785c-42de-9c06-f82d7725c21c",
    "category": "pizze_bianche",
    "name": "Estate",
    "description": "Mozzarella, rucola, pachino e grana",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 31
  },
  {
    "id": "10f108a5-d58e-48d9-b1cf-7f6b86e7ecbe",
    "category": "pizze_bianche",
    "name": "Crudina",
    "description": "Mozzarella e prosciutto crudo",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 32
  },
  {
    "id": "fdeb969c-d30a-4332-8d70-6c030200912a",
    "category": "pizze_bianche",
    "name": "Quattro Formaggi",
    "description": "Mozzarella, gorgonzola, parmigiano, scamorza affumicata",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 33
  },
  {
    "id": "5017f10c-14cb-4550-bff0-d29f3832d07b",
    "category": "pizze_bianche",
    "name": "Ortolana",
    "description": "Mozzarella, pachino, melanzane, zucchine e peperoni",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 34
  },
  {
    "id": "0a407194-f273-4dc4-949a-d38071ca5466",
    "category": "pizze_bianche",
    "name": "Porcina",
    "description": "Mozzarella, porcini e salsiccia",
    "price": "€9,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 35
  },
  {
    "id": "de2b3202-366a-4da6-891c-c2246803877a",
    "category": "pizze_bianche",
    "name": "Saporita",
    "description": "Mozzarella, salame piccante, pancetta e gorgonzola",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 36
  },
  {
    "id": "8204ac3c-31df-4c07-a90e-ad1d16af1651",
    "category": "pizze_bianche",
    "name": "Boscaiola",
    "description": "Mozzarella, salsiccia e funghi",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 37
  },
  {
    "id": "7529d508-a16b-4c37-8cf2-22e932521819",
    "category": "panini",
    "name": "Il Classico",
    "description": "Panino con hamburger di scottona, pomodoro, insalata, ketchup e maionese",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 38
  },
  {
    "id": "65ba3099-dad2-46d7-a145-d45e70fa5f3d",
    "category": "panini",
    "name": "Il Classico XL",
    "description": "Panino con doppio hamburger di scottona, pomodoro, insalata, ketchup e maionese",
    "price": "€11,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 39
  },
  {
    "id": "f3f9f1a0-ad18-4d3c-afb4-3d8f9073ee46",
    "category": "panini",
    "name": "Red Cheese",
    "description": "Panino con hamburger di scottona, cheddar, insalata, pomodoro e salsa Red Stone",
    "price": "€9,00",
    "format": "",
    "allergens": "Latte",
    "image": "",
    "available": true,
    "order": 40
  },
  {
    "id": "d35a0049-55c3-403f-bfb9-249ef171a25d",
    "category": "panini",
    "name": "Red Cheese XL",
    "description": "Panino con doppio hamburger di scottona, cheddar, insalata, pomodoro e salsa Red Stone",
    "price": "€12,00",
    "format": "",
    "allergens": "Latte",
    "image": "",
    "available": true,
    "order": 41
  },
  {
    "id": "e7d87fe2-ec3d-4bca-8c30-08073a0c2d23",
    "category": "panini",
    "name": "Red Chicken",
    "description": "Ciabatta con cotoletta, formaggio, pomodoro, insalata, bacon e salsa Red Stone",
    "price": "€7,00",
    "format": "",
    "allergens": "Latte",
    "image": "",
    "available": true,
    "order": 42
  },
  {
    "id": "aea322c3-6acc-46de-9f76-fffcc30b798e",
    "category": "panini",
    "name": "Tosto",
    "description": "Panino con hamburger affumicato di scottona, rösti di patate, cheddar, bacon, insalata, cipolla rossa agrodolce, salsa bbq e maionese",
    "price": "€10,00",
    "format": "",
    "allergens": "Latte",
    "image": "",
    "available": true,
    "order": 43
  },
  {
    "id": "8ec413f5-1b31-4d04-b2b2-3f7255ced58e",
    "category": "panini",
    "name": "Panino Scomposto",
    "description": "Panino con hamburger di scottona, scamorza o cheddar e nel piatto pomodoro, insalata e bacon…per condirlo come vuoi tu!",
    "price": "€8,00",
    "format": "",
    "allergens": "Latte",
    "image": "",
    "available": true,
    "order": 44
  },
  {
    "id": "0565bda1-6cbc-455a-af6f-eb7b8cc1d32e",
    "category": "panini",
    "name": "Hot Dog",
    "description": "Ciabatta con würstel, insalata, pomodoro, salsa Red Stone e una goccia di tabasco",
    "price": "€7,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 45
  },
  {
    "id": "ceb5778f-6ba5-4ad2-b25f-3e2417d94296",
    "category": "panini",
    "name": "Pollosauro",
    "description": "Ciabatta con petto di pollo panato e fritto, insalata, bacon e salsa yogurt",
    "price": "€9,00",
    "format": "",
    "allergens": "Latte",
    "image": "",
    "available": true,
    "order": 46
  },
  {
    "id": "9e016822-9f81-4fc1-a2dc-561be45b505b",
    "category": "panini",
    "name": "La Ciociara",
    "description": "Ciabatta con salsiccia, broccoletti, pecorino fresco al peperoncino e maionese",
    "price": "€9,00",
    "format": "",
    "allergens": "Latte",
    "image": "",
    "available": true,
    "order": 47
  },
  {
    "id": "22fa81d7-0e88-488e-b71d-4e629c70c46f",
    "category": "vini_bianchi",
    "name": "Pinot Grigio",
    "description": "",
    "price": "€18,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 48
  },
  {
    "id": "374b3896-f26c-4b2b-b0da-907b02237a59",
    "category": "vini_bianchi",
    "name": "Vermentino di Sardegna",
    "description": "",
    "price": "€22,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 49
  },
  {
    "id": "1b52b49b-651a-42d0-a034-c9ba5bf5d23c",
    "category": "vini_bianchi",
    "name": "Ribolla Gialla",
    "description": "",
    "price": "€20,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 50
  },
  {
    "id": "f94d9e78-17a6-435c-bf54-caa8772cb90c",
    "category": "vini_bianchi",
    "name": "LuSciablì Cococciola (Marchesi de' Cordano)",
    "description": "",
    "price": "€20,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 51
  },
  {
    "id": "fa36da8a-51d0-431d-9ccc-73564963347c",
    "category": "vini_bianchi",
    "name": "Pecorino",
    "description": "",
    "price": "€18,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 52
  },
  {
    "id": "aa30e360-6bd9-4bcf-8ceb-1302bc333bfc",
    "category": "vini_bianchi",
    "name": "Conubium",
    "description": "",
    "price": "€18,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 53
  },
  {
    "id": "3b9317b2-012a-42f4-80f6-129f06984564",
    "category": "vini_bianchi",
    "name": "Riesling",
    "description": "",
    "price": "€22,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 54
  },
  {
    "id": "b300eb71-6763-4ff8-b8c0-51458490024b",
    "category": "vini_bianchi",
    "name": "Chardonnay",
    "description": "",
    "price": "€18,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 55
  },
  {
    "id": "6c5fdcd3-9b5a-4f48-b943-b9a1e4f2c07b",
    "category": "vini_rossi",
    "name": "Merlot (Astoria)",
    "description": "",
    "price": "€22,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 56
  },
  {
    "id": "9b58ee1e-0a54-4eec-a7af-c3da114acbe2",
    "category": "vini_rossi",
    "name": "Pinot Noir (Astoria)",
    "description": "",
    "price": "€22,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 57
  },
  {
    "id": "dd68fc3d-2040-438f-8757-4f9585ee063c",
    "category": "vini_rossi",
    "name": "Refosco (Forchir)",
    "description": "",
    "price": "€20,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 58
  },
  {
    "id": "3719a69f-35c8-4bfc-ae12-33a8e44226b7",
    "category": "vini_rossi",
    "name": "Cabernet Sauvignon (Forchir)",
    "description": "",
    "price": "€20,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 59
  },
  {
    "id": "2de3368a-ff7b-4e92-9c22-6a68a4b4d796",
    "category": "vini_rossi",
    "name": "Refoscone (Forchir)",
    "description": "",
    "price": "€22,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 60
  },
  {
    "id": "922eb1f4-a853-4ca0-816b-d1450a435d89",
    "category": "vini_rossi",
    "name": "Sangiovese (Bocelli)",
    "description": "",
    "price": "€18,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 61
  },
  {
    "id": "636b51fe-ba2e-4a26-9d5d-0ad33325b75f",
    "category": "vini_rossi",
    "name": "Cabernet Sauvignon (Astoria)",
    "description": "",
    "price": "€22,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 62
  },
  {
    "id": "9a7299ce-3af4-4de6-8fd1-95734dbbfcf7",
    "category": "vini_rossi",
    "name": "Cabernet Franc (Ca' di Rajo)",
    "description": "",
    "price": "€20,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 63
  },
  {
    "id": "0be2b82e-dae9-4bb3-815b-0355ca20a200",
    "category": "vini_rossi",
    "name": "Barriano (Cantina Villa Gianna)",
    "description": "",
    "price": "€22,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 64
  },
  {
    "id": "ae787ae7-426c-4066-81b5-7cd53eb43611",
    "category": "vini_rossi",
    "name": "Cabernet Sauvignon (Ca' di Rajo)",
    "description": "",
    "price": "€20,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 65
  },
  {
    "id": "06de37b0-13d0-49d3-986b-968e68f05738",
    "category": "vini_rossi",
    "name": "Tufaliccio",
    "description": "",
    "price": "€25,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 66
  },
  {
    "id": "f909f3cf-e36c-4d96-9f25-07f99f436110",
    "category": "vini_rossi",
    "name": "Cesanese Nero",
    "description": "",
    "price": "€22,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 67
  },
  {
    "id": "ed250d64-403d-405d-a0dd-9b0b9af04734",
    "category": "birre_bottiglia",
    "name": "Heineken 66cl",
    "description": "",
    "price": "€3,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 68
  },
  {
    "id": "2b1dceaa-0460-4acf-9158-beb11725a642",
    "category": "birre_bottiglia",
    "name": "Heineken 33cl",
    "description": "",
    "price": "€2,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 69
  },
  {
    "id": "c93119f0-92f3-486d-a1ec-6eb22e0d746c",
    "category": "birre_bottiglia",
    "name": "Corona 33cl",
    "description": "",
    "price": "€3,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 70
  },
  {
    "id": "e51be411-f31a-4d7e-9d0d-2b067c0beb70",
    "category": "birre_bottiglia",
    "name": "Tennent's Super 33cl",
    "description": "",
    "price": "€3,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 71
  },
  {
    "id": "a7dd372e-ac39-4c4a-b6ff-b9b98b2a73e8",
    "category": "birre_bottiglia",
    "name": "Speciali",
    "description": "",
    "price": "€4,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 72
  },
  {
    "id": "f060c95c-c2ef-4447-99cf-c4181f26a6c4",
    "category": "birre_spina",
    "name": "Stella Artois 0,20",
    "description": "",
    "price": "€3,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 73
  },
  {
    "id": "bb576b02-87e6-4981-9255-4948738ef889",
    "category": "birre_spina",
    "name": "Stella Artois 0,40",
    "description": "",
    "price": "€5,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 74
  },
  {
    "id": "bb17f418-5f89-4d3d-a1f0-4d41cd0c5e2f",
    "category": "birre_spina",
    "name": "Stella Artois 0,50",
    "description": "",
    "price": "€6,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 75
  },
  {
    "id": "c6c40aa1-2e79-4de3-8865-772c100a63ce",
    "category": "birre_spina",
    "name": "Melløn Bionda Artigianale 0,20",
    "description": "",
    "price": "€3,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 76
  },
  {
    "id": "a4dfa56d-5464-45a7-97ce-e6368c80f2b6",
    "category": "birre_spina",
    "name": "Melløn Bionda Artigianale 0,40",
    "description": "",
    "price": "€5,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 77
  },
  {
    "id": "f097c0de-11f4-4713-9e68-c51e6ae0b22b",
    "category": "birre_spina",
    "name": "Hoppy Fish IPA 0,30",
    "description": "",
    "price": "€4,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 78
  },
  {
    "id": "b9f18fd6-ec08-4555-b0a7-dffeca8a238d",
    "category": "birre_spina",
    "name": "Hoppy Fish IPA 0,50",
    "description": "",
    "price": "€6,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 79
  },
  {
    "id": "d4003d34-8287-4507-8850-ed9d53053423",
    "category": "birre_spina",
    "name": "Saxon Rossa 0,33",
    "description": "",
    "price": "€4,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 80
  },
  {
    "id": "7dbebaba-5bb9-4e86-93e7-6735b723917c",
    "category": "bevande",
    "name": "Acqua Naturale 1lt",
    "description": "",
    "price": "€2,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 81
  },
  {
    "id": "a62683ec-7943-48c3-b105-fa4d98c4c6c9",
    "category": "bevande",
    "name": "Acqua Frizzante 1lt",
    "description": "",
    "price": "€2,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 82
  },
  {
    "id": "324fbea5-8c3f-4554-ab0c-4ffa342d9e6c",
    "category": "bevande",
    "name": "Coca Cola 33cl",
    "description": "",
    "price": "€2,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 83
  },
  {
    "id": "3e8a2154-5f31-4397-b9f0-cc52b4609786",
    "category": "bevande",
    "name": "Coca Cola 1lt",
    "description": "",
    "price": "€3,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 84
  },
  {
    "id": "38543214-b5d6-4381-8521-6e2cacf6e6f7",
    "category": "bevande",
    "name": "Fanta 33cl",
    "description": "",
    "price": "€2,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 85
  },
  {
    "id": "41f58574-2e48-497a-8b02-d4310b70fadf",
    "category": "bevande",
    "name": "Crodino",
    "description": "",
    "price": "€2,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 86
  },
  {
    "id": "6ec761dd-7f88-4a24-a5f1-b8e417163678",
    "category": "bevande",
    "name": "Lemonsoda",
    "description": "",
    "price": "€2,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 87
  },
  {
    "id": "2213de26-5ee2-4c77-9ed5-2cb46687f3ff",
    "category": "bevande",
    "name": "Oransoda",
    "description": "",
    "price": "€2,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 88
  },
  {
    "id": "13fbe3f2-ac02-448e-8305-fb40d59c35a2",
    "category": "bevande",
    "name": "Cocktail Sanpellegrino",
    "description": "",
    "price": "€3,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 89
  },
  {
    "id": "d0e4ce5b-4adc-4b91-9d0d-6b144b5694a8",
    "category": "bevande",
    "name": "Cedrata Tassoni",
    "description": "",
    "price": "€3,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 90
  },
  {
    "id": "f7bdf304-9c4e-4915-aac1-cd55e2c393c9",
    "category": "bevande",
    "name": "Succo di frutta",
    "description": "",
    "price": "€3,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 91
  },
  {
    "id": "1dbb52b8-2f48-4ad5-955f-fc7429e35d39",
    "category": "amari",
    "name": "Amari",
    "description": "",
    "price": "€3,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 92
  },
  {
    "id": "1a89933c-fe63-4920-9b02-750922752fce",
    "category": "amari",
    "name": "Grappa bianca",
    "description": "",
    "price": "€3,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 93
  },
  {
    "id": "37d459dc-df7b-49ab-b9b2-9cf6b4e8ffe7",
    "category": "amari",
    "name": "Grappa barricata",
    "description": "",
    "price": "€4,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 94
  },
  {
    "id": "64aff394-dba2-429d-bc37-259d76d1af7b",
    "category": "amari",
    "name": "Rum",
    "description": "",
    "price": "€5,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 95
  },
  {
    "id": "28aaef40-865e-40c8-9d5d-1b15dfec47f6",
    "category": "amari",
    "name": "Rum Special",
    "description": "",
    "price": "€7,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 96
  },
  {
    "id": "b94519ca-1ad4-4805-9bd7-37de2c03343e",
    "category": "amari",
    "name": "Whiskey",
    "description": "",
    "price": "€5,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 97
  },
  {
    "id": "7e8d17de-b369-4a93-9321-7befb507e4a9",
    "category": "caffetteria",
    "name": "Caffè",
    "description": "",
    "price": "€1,20",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 98
  },
  {
    "id": "7ead82aa-0531-4048-b99a-1c917c45e1a1",
    "category": "caffetteria",
    "name": "Decaffeinato",
    "description": "",
    "price": "€1,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 99
  },
  {
    "id": "ffe09b83-8af5-417d-8e9f-595b8c8f0dd0",
    "category": "caffetteria",
    "name": "Ginseng",
    "description": "",
    "price": "€1,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 100
  },
  {
    "id": "e59a353d-ff4e-48c6-94df-f017621e0827",
    "category": "caffetteria",
    "name": "Orzo",
    "description": "",
    "price": "€1,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 101
  },
  {
    "id": "979680a6-2e3e-4163-ae2f-11bd4365fc6f",
    "category": "primi",
    "name": "Tagliolini ai funghi porcini",
    "description": "",
    "price": "€10,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 200
  },
  {
    "id": "e76628b6-d75b-4fd3-84fb-4d10390b03aa",
    "category": "primi",
    "name": "Fusilloni al ragù",
    "description": "",
    "price": "€9,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 201
  },
  {
    "id": "950ffab3-cfb2-4dee-adf5-6d9f9f16c291",
    "category": "primi",
    "name": "Rigatoni all'amatriciana",
    "description": "",
    "price": "€9,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 202
  },
  {
    "id": "ef14cf79-2d6c-4663-b7cb-b3418f41e75f",
    "category": "primi",
    "name": "Gnocchi pomodoro e mozzarella",
    "description": "",
    "price": "€9,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 203
  },
  {
    "id": "b5a8741e-4a39-4450-8a63-6cda41fa3c0f",
    "category": "primi",
    "name": "Strigoli al pesto genovese",
    "description": "",
    "price": "€9,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 204
  },
  {
    "id": "dd0effcb-c6dc-465b-a0ee-e0432af2b287",
    "category": "primi",
    "name": "Lasagne alla bolognese",
    "description": "",
    "price": "€9,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 205
  },
  {
    "id": "45e97a71-2d16-4afc-bc75-5664fc07ae73",
    "category": "primi",
    "name": "Spaghetti cacio e pepe",
    "description": "",
    "price": "€10,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 206
  },
  {
    "id": "6ae8558a-925d-4b4c-9571-b3a13f73fe43",
    "category": "secondi",
    "name": "Polpette al sugo",
    "description": "",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 207
  },
  {
    "id": "9670ba45-140e-4cba-a0eb-4b68713ced9b",
    "category": "secondi",
    "name": "Tagliata di manzo",
    "description": "",
    "price": "€6,00 l'etto",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 208
  },
  {
    "id": "adda8b18-9407-42c5-a273-ef0f94d3ce03",
    "category": "secondi",
    "name": "Scamorza al forno con prosciutto",
    "description": "",
    "price": "€8,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 209
  },
  {
    "id": "5b1c1ae3-3229-4b11-92ec-fce574e62e73",
    "category": "secondi",
    "name": "Salsicce alla piastra",
    "description": "",
    "price": "€6,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 210
  },
  {
    "id": "234106c4-fe32-45fb-b065-a539131eb573",
    "category": "contorni",
    "name": "Insalatona Red Stone",
    "description": "",
    "price": "€10,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 211
  },
  {
    "id": "6851c667-c3b6-458a-9581-918cdb0bd457",
    "category": "contorni",
    "name": "Insalata verde o mista",
    "description": "",
    "price": "€4,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 212
  },
  {
    "id": "4b31bbb5-b1d5-484c-aeb8-9846d10033cd",
    "category": "contorni",
    "name": "Verdure grigliate",
    "description": "",
    "price": "€4,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 213
  },
  {
    "id": "14effb0e-148a-48c1-ab1d-eaae384e8262",
    "category": "contorni",
    "name": "Patatine fritte",
    "description": "",
    "price": "€4,50",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 214
  },
  {
    "id": "71f0d56b-708f-4c4c-b4f1-7feca81ecdeb",
    "category": "bambini",
    "name": "Piatto di salumi a scelta",
    "description": "",
    "price": "€5,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 215
  },
  {
    "id": "6475fa13-cf40-4ebb-8a21-09324e49c582",
    "category": "bambini",
    "name": "Pasta in bianco o al pomodoro",
    "description": "",
    "price": "€5,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 216
  },
  {
    "id": "424ded7a-d5ab-4b48-b726-8f66996e36cc",
    "category": "bambini",
    "name": "Cotoletta di pollo",
    "description": "",
    "price": "€5,00",
    "format": "",
    "allergens": "",
    "image": "",
    "available": true,
    "order": 217
  }
];
